import * as React from "react";
import { connect } from "react-redux";
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import styled from "styled-components";
import { TransactionLogState } from "./Store/types";
import { TransactionDevice } from "@Safemate/Model/TransactionDevice";
import { getDevice, getTransactions, logTxLogAccess, pollTransactions } from "./Store/routines";
import { useParams } from "react-router";
import { LogParams, MapType } from "@Safemate/map";
import Loader from "@Elements/Loader";
import DeviceHeader, { StyledSpan } from "@Safemate/DeviceHeader";
import { useIntl } from "react-intl";
import Filter from "./Filter";
import { AppState } from "@Safemate/Store/types";
import Log from "./Log";
import ArrowUp from "@Elements/Icon/Icons/arrows/ArrowUp";
import ArrowDown from "@Elements/Icon/Icons/arrows/ArrowDown";
import { MainSpinner } from "@Safemate/Spinner";
import Graph from "./Graph";
import Analysis from "@Elements/Icon/Icons/FontAwesome/Analysis";
import { SvgButton } from "@Safemate/styles";

const GraphExpand = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const GraphBar = styled.div`
    width: 100%;
    padding: 15px;
    background: ${props => props.theme.colors.statusBarBackground};
`;

interface TransactionLogProps{
    device: TransactionDevice;
    getDevice: Routine<ActionFunctionAny<Action<any>>>;
    pollTransactions: Routine<ActionFunctionAny<Action<any>>>;
    logTxLogAccess: Routine<ActionFunctionAny<Action<any>>>;
}

const mapStateToProps = ({ txLog: { device: { device }}}: AppState) => {
    return {
        device
    }
}

const mapDispatchToProps = {
    getDevice,
    pollTransactions,
    logTxLogAccess
}

const TransactionLog = connect(mapStateToProps, mapDispatchToProps)(({ pollTransactions, getDevice, logTxLogAccess, device }: TransactionLogProps) => {

    const { id } = useParams<LogParams>();
    const deviceId = parseInt(id);

    const { formatMessage } = useIntl();

    const [displayGraph, setDisplayGraph] = React.useState(false);


    React.useEffect(() => {

      let transactionInterval: any;

      logTxLogAccess(deviceId);
        
      transactionInterval = setInterval(() => {
        pollTransactions()
      }, 10000);

      return () => {
        setTimeout(() => {
          clearTimeout(transactionInterval);
        }, 1000)
      }

    }, [])

    React.useEffect(() => {
        getDevice(deviceId);
    }, [deviceId])

    if(!device) return <MainSpinner style={{marginLeft: "-16em"}}/>;

  return(
        <>
          <Filter/>
          <div>
            <DeviceHeader 
                dehaId={device.dehaId}
                name={device.deviceName} 
                deviId={device.id} 
                custId={device.custId} 
                isTwin={device.minionTwin} 
                serialNumber={device.serialNumber}
                hasRecipient={device.hasRecipient}
                lastMsgIn={device.lastMsgIn}
            >
                <>
                <StyledSpan>
                    {` ${formatMessage({ id: "transactionLogFor", defaultMessage: "Transaksjonslogg for" })} `}
                </StyledSpan>
                </>
            </DeviceHeader>
            <SvgButton onClick={() => setDisplayGraph(!displayGraph)}>
                <Analysis medium/>{formatMessage({id: "showAnalysisTool", defaultMessage: "Vis analyseverktøy"})}
            </SvgButton>
            <Graph display={displayGraph}/>
            <Log/>
          </div>
        </>
    )
})

export default TransactionLog;
